import { SystemAuthorizations } from 'shell/authorizations/system';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.OperatoreQuery],
  create: [SystemAuthorizations.OperatoreAdd],
  edit: [SystemAuthorizations.OperatoreUpdate],
  delete: [SystemAuthorizations.OperatoreDelete],
});
